type SetGoogleConversionType = Record<
  "firstName" | "lastName" | "email" | "phoneNumber",
  string
>;

export const setGoogleConversion = (attributes: SetGoogleConversionType) => {
  if (typeof window !== `undefined`) {
    const { firstName, lastName, email, phoneNumber } = attributes;
    window.google_conversion_first_name = firstName;
    window.google_conversion_last_name = lastName;
    window.google_conversion_email = email;
    window.google_conversion_phone_number = phoneNumber;
  }
};
